import Button from "../../Custom/Button/Button";
import { useGlobalContext } from "../../../Context/Context";
import axios from "axios";

const styles = {
  button: {
    padding: "10px 20px",
    fontWeight: "bold"
  },
  divBtn: {
    width: "90%",
    height: "40px"
  },
  container: {
    display: "flex",
    flexDirection: "column",
    gap: "15px",
    padding: "5px"
  },
  btnContainer: {
    padding: "5px",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    gap: "7px",
    alignItems: "center"
  }
};

const ArhivirajIzmeniBtns = ({ openAzuriranje, companyId }) => {
  const { dictionary, baseUrl, setSelectedCompany, setSelectedAccount } =
    useGlobalContext();

  const handleArhiviraj = async () => {
    try {
      const { data } = await axios.post(
        `${baseUrl}/companies/archiveToggle.php`,
        {
          company_id: companyId
        }
      );
      if (data.status === 200) {
        setSelectedCompany((prev) => ({
          ...prev,
          accounts: prev.accounts.map((account) =>
            account.company_id === companyId
              ? { ...account, archived: "1" }
              : account
          )
        }));
        setSelectedAccount(null);
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div style={styles.btnContainer}>
      <div onClick={() => openAzuriranje()} style={styles.divBtn}>
        <Button style={styles.button}>{dictionary["izmeni"]}</Button>
      </div>
      <div onClick={handleArhiviraj} style={styles.divBtn}>
        <Button activation={true} style={styles.button}>
          {dictionary["arhiviraj"]}
        </Button>
      </div>
    </div>
  );
};

export default ArhivirajIzmeniBtns;
